import { connectToStores } from 'fluxible-addons-react';
import { intlShape } from 'react-intl';
import DocumentTitle from 'react-document-title';
import DraftStepStore from 'launch/stores/DraftStepStore';
import React from 'react';

const Title = ({ step }, { intl: { formatMessage } }) => {
    const stepTitle = formatMessage({ id: `steps.${step}` });
    const category = formatMessage({ id: 'category' });

    return <DocumentTitle title={`${stepTitle} | ${category} | 99designs`} />;
};

Title.contextTypes = {
    intl: intlShape.isRequired,
};

export default connectToStores(Title, [DraftStepStore], (context, props) => {
    const step = context.getStore(DraftStepStore).currentStep;
    return { step };
});
